import { useReveal } from "../../lib/reveal";

const empresas = [
  {
    logo: "https://customer-assets.emergentagent.com/job_kit-memoria/artifacts/88jpsv6z_RemindBrindes235x182.png",
    name: "Remind Brindes",
    tag: "Produtos promocionais inteligentes",
    body:
      "Brindes diferenciados e kits temáticos para cursos, mentorias e ações que precisam virar experiência. Atende produtores que buscam ressignificar o brinde como parte da jornada do aluno.",
    testid: "grupo-card-remind",
  },
  {
    logo: "https://customer-assets.emergentagent.com/job_kit-memoria/artifacts/fa0ghg12_PrestigiareBrindes235x47.png",
    name: "Prestigiare Brindes",
    tag: "Material promocional para grandes marcas",
    body:
      "Soluções de brindes corporativos para campanhas de incentivo, eventos institucionais e fidelização de clientes em escala. Para marcas que precisam de processo, volume e padrão.",
    testid: "grupo-card-prestigiare",
  },
];

export default function GrupoMetier() {
  const { ref, visible } = useReveal();
  return (
    <section
      id="grupo"
      ref={ref}
      data-testid="grupo-section"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ backgroundColor: "#FAFAFA" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start reveal ${visible ? "in" : ""}`}>
          <div className="lg:col-span-5">
            <p className="overline">Grupo de comunicação</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1C1C1C] mt-6 leading-[1.02]">
              Uma <em className="italic text-[#556052]">casa</em>, dois selos especialistas.
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#556052] font-light leading-relaxed max-w-md">
              A <strong className="font-medium text-[#1C1C1C]">MetierCom</strong> é o grupo de
              comunicação que reúne duas empresas de material promocional, cada uma com seu
              perfil de cliente — somando duas décadas de expertise no mercado de brindes
              diferenciados.
            </p>
            <div className="mt-10 flex items-center gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_kit-memoria/artifacts/j1su7rjr_MetierCom_Logo150x34.png"
                alt="MetierCom"
                className="h-8 w-auto"
                data-testid="metiercom-logo-grupo"
              />
              <div className="hairline-gold" />
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {empresas.map((e) => (
              <article
                key={e.name}
                data-testid={e.testid}
                className="bg-[#0B2E24] text-[#FAFAFA] p-8 md:p-10 transition-all duration-500 hover:-translate-y-1 flex flex-col"
              >
                <div className="h-20 flex items-start">
                  <img
                    src={e.logo}
                    alt={e.name}
                    className="max-h-20 w-auto object-contain"
                  />
                </div>
                <div className="hairline-gold my-6" />
                <p className="overline text-[#C5A059]">{e.tag}</p>
                <h3 className="font-serif text-2xl md:text-3xl mt-3 leading-tight">{e.name}</h3>
                <p className="mt-4 text-sm md:text-base font-light text-[#FAFAFA]/80 leading-relaxed">
                  {e.body}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
